/**
 *  Apex CRO: JSN-011, consolidated USP module below the buy box.
 *
 *  Gathers the scattered product page USPs into one module and hides the
 *  originals. Copy comes from the locale files and the Apex CRO theme settings
 *  via snippets/apex-cro-product.liquid, so every store gets its own text.
 */
(function (root) {
  'use strict';

  var configNode = root.document.getElementById('ApexUspConfig');
  if (!configNode) return;
  var locale = JSON.parse(configNode.textContent);

  var CONFIG = {
    removals: {
      uspLine: true,
      trustLine: true,
      proofSection: true,
      iconList: true,
      marquee: true,
      ppCards: true,
      ppCompare: false,
      galleryBadges: false
    },
    showTrustFooter: true,
    proofPhotos: 5,
    anchorTimeoutMs: 15000,
    hydrateWindowMs: 8000,
    /* Material accordion heading: "Materiale & vask", "Material & Pflege" and so on. */
    materialHeading: /^\s*material/i,
    selectors: {
      inner: '.product-information--inner',
      observeRoot: '.product-information',
      anchors: [
        '.product-information--inner > product-recommendations.complementary-products',
        '.product-information--inner > .product--icon-list',
        '.product-information--inner > collapsible-row.product__accordion'
      ],
      vendorLine: 'p.product--text.style_vendor',
      variantSelects: '.product-information--inner variant-selects',
      stockWidget: '.product-information--inner #sdw-stock_delivery_widget',
      richTextSection: '.shopify-section.section-rich-text',
      accordions: 'collapsible-row.product__accordion, .product__accordion',
      accordionHeading: 'summary, .accordion__title, h2, h3',
      shippingHeading: /fragt|frakt|versand|verzending|shipping|toimitus|livraison|spedizione|envío|kargo/,
      returnLink: 'a[href*="reversio"]',
      trustLink: 'a[href*="trustpilot"]',
      proofPhotos: '.scrolling-images--item img, .scrolling-images img',
      iconList: '.product-information--inner > .product--icon-list',
      marquee: '.product-information--inner > .product--scrolling-text',
      ppCards: '.product-information--inner > .pp-cards-wrap',
      ppCompare: '.product-information--inner > .pp-compare'
    }
  };

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function queryAll(scope, selector) {
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  var svgNamespace = 'http' + '://www.w3.org/2000/svg';
  var iconShapes = {
    material: [['path', { d: 'M12 3c-4 2-6 5-6 8.5A5.5 5.5 0 0 0 11.5 17C15 17 18 14 18 9c-3 0-5.8.7-8 2.8' }], ['path', { d: 'M7 20c.8-4 3-7 7-9' }]],
    quality: [['path', { d: 'm12 3 2.7 5.5 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1-4.4-4.3 6.1-.9Z' }]],
    design: [['path', { d: 'M12 3 4 7v10l8 4 8-4V7l-8-4Z' }], ['path', { d: 'm4 7 8 4 8-4M12 11v10' }]],
    service: [['path', { d: 'M3 7h11v9H3zM14 10h4l3 3v3h-7z' }], ['circle', { cx: '7', cy: '18', r: '2' }], ['circle', { cx: '17', cy: '18', r: '2' }]]
  };

  /* Builds an inline SVG with DOM calls (no HTML strings, per Apex's treatment review). */
  function buildSvg(doc, attributes, shapes) {
    var svg = doc.createElementNS(svgNamespace, 'svg');
    Object.keys(attributes).forEach(function (name) { svg.setAttribute(name, attributes[name]); });
    shapes.forEach(function (shape) {
      var node = doc.createElementNS(svgNamespace, shape[0]);
      Object.keys(shape[1]).forEach(function (name) { node.setAttribute(name, shape[1][name]); });
      svg.appendChild(node);
    });
    return svg;
  }

  function buildIcon(doc, category) {
    return buildSvg(doc, { viewBox: '0 0 24 24', width: '20', height: '20', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.7', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', focusable: 'false', 'aria-hidden': 'true' }, iconShapes[category] || iconShapes.material);
  }

  function buildStar(doc) {
    return buildSvg(doc, { viewBox: '0 0 20 20', width: '14', height: '14', fill: 'currentColor', focusable: 'false', 'aria-hidden': 'true' }, [['path', { d: 'M10 1.6l2.6 5.4 5.9.8-4.3 4.1 1.1 5.9L10 15l-5.3 2.8 1.1-5.9L1.5 7.8l5.9-.8z' }]]);
  }

  function buildSpan(doc, className) {
    var span = doc.createElement('span');
    span.className = className;
    return span;
  }

  /* The legacy proof rich-text section (Trustpilot + 2.000.000 sold) exists on all three stores with different wording. */
  function isLegacyProofText(text) {
    var value = normalize(text);
    return /trustpilot/.test(value) && /2[.\s]?000[.\s]?000/.test(value);
  }

  /* Product-photo stack for the header. Optional: no photos means no stack, the module still renders. */
  function readProofPhotos(doc, limit) {
    var seen = {};
    var photos = [];
    queryAll(doc, CONFIG.selectors.proofPhotos).some(function (img) {
      var source = img.getAttribute('data-srcset') || img.getAttribute('srcset') || img.getAttribute('data-src') || img.getAttribute('src') || '';
      source = source.split(',')[0].trim().split(/\s+/)[0];
      if (!source) return false;
      var base = source.replace(/\?.*$/, '');
      if (!/\.(jpe?g|png|webp)$/i.test(base) || seen[base]) return false;
      seen[base] = true;
      photos.push({ base: base, alt: '' });
      return photos.length >= limit;
    });
    return photos;
  }

  function photoUrl(base, size) {
    return base + '?width=' + size + '&height=' + size + '&crop=center';
  }

  function findTrustUrl(doc) {
    var link = queryAll(doc, CONFIG.selectors.trustLink).filter(function (node) {
      return /^https?:/.test(node.href);
    })[0];
    return link ? link.href : '';
  }

  /* Return-portal link from the shipping accordion: the reversio link is present on all stores, heading match is the fallback. */
  function findReturnUrl(doc) {
    var accordions = queryAll(doc, CONFIG.selectors.accordions);
    var reversioLink = null;
    accordions.some(function (node) {
      reversioLink = node.querySelector(CONFIG.selectors.returnLink);
      return Boolean(reversioLink);
    });
    if (reversioLink && reversioLink.href) return reversioLink.href;
    var shipping = accordions.filter(function (node) {
      var heading = normalize((node.querySelector(CONFIG.selectors.accordionHeading) || node).textContent);
      return CONFIG.selectors.shippingHeading.test(heading);
    })[0];
    var link = shipping ? shipping.querySelector('a[href]') : null;
    return link && /^https?:/.test(link.href) ? link.href : '';
  }

  function readProductContext(doc) {
    return {
      returnUrl: findReturnUrl(doc),
      trustUrl: findTrustUrl(doc),
      photos: readProofPhotos(doc, CONFIG.proofPhotos),
      material: readMaterialClaim(doc)
    };
  }

  /* Visible text of a content node, with block boundaries kept as spaces. */
  function readableText(node) {
    if (!node) return '';
    var text = typeof node.innerText === 'string' && node.innerText.trim() ? node.innerText : node.textContent;
    /* A line break between two lines of copy ends a sentence, so "GOTS-22172\nVask 30°C" does not run together. */
    return String(text || '').replace(/([^.!?:\s])[ \t]*\n+\s*/g, '$1. ').replace(/\s+/g, ' ').trim();
  }

  /* Splits copy into sentences without lookbehind (older Safari). */
  function splitSentences(text) {
    var parts = String(text || '').match(/[^.!?]+[.!?]+(?=\s|$)|[^.!?]+$/g) || [];
    return parts.map(function (part) { return part.trim(); }).filter(Boolean);
  }

  /* Material row source, per product (ASP-1221): the "Materiale & vask" / "Material & Pflege" accordion — first sentence is the
     headline, second the subline, the rest opens as detail. Empty accordion → null → the module renders without the material row
     (PO decision 2026-10-02: the shop fills the text over time; no description fallback). */
  function readMaterialClaim(doc) {
    var materialRow = queryAll(doc, CONFIG.selectors.accordions).filter(function (node) {
      return CONFIG.materialHeading.test(readableText(node.querySelector(CONFIG.selectors.accordionHeading)));
    })[0];
    var materialText = materialRow ? readableText(materialRow.querySelector('.collapsible__content, .accordion__content')) : '';
    var sentences = splitSentences(materialText);
    if (sentences.length) {
      return {
        source: 'material',
        head: sentences[0].replace(/[.!?]+$/, ''),
        body: sentences[1] || '',
        detail: sentences.slice(2).join(' ')
      };
    }
    return null;
  }

  /* The base material claim (icon, ids) with this product's own copy applied. */
  function materialClaimFor(baseClaim, material) {
    return {
      id: baseClaim.id,
      category: baseClaim.category,
      source: material.source,
      head: material.head,
      body: material.body,
      detail: material.detail
    };
  }

  /* Anchor chain (after complementary products, else icon list, else first accordion); last resort appends into the buy box. */
  function resolvePlacement(doc, allowLastResort) {
    var anchor = null;
    CONFIG.selectors.anchors.some(function (selector) {
      anchor = doc.querySelector(selector);
      return Boolean(anchor);
    });
    if (anchor) return { node: anchor, mode: 'afterend', selector: anchor.tagName.toLowerCase() + '.' + String(anchor.className || '').split(/\s+/)[0] };
    if (!allowLastResort) return null;
    var inner = doc.querySelector(CONFIG.selectors.inner);
    return inner ? { node: inner, mode: 'append', selector: CONFIG.selectors.inner } : null;
  }

  function placeModule(placement, module) {
    if (placement.mode === 'afterend') {
      if (placement.node.nextElementSibling !== module) placement.node.insertAdjacentElement('afterend', module);
      return;
    }
    if (module.parentNode !== placement.node) placement.node.appendChild(module);
  }

  /* Marks the scattered control blocks that the CSS hides; a block that does not exist on this product is simply skipped. */
  function markDuplicates(doc) {
    queryAll(doc, '.apex-uspm-dup').forEach(function (node) { node.classList.remove('apex-uspm-dup'); });

    if (CONFIG.removals.uspLine) {
      queryAll(doc, CONFIG.selectors.variantSelects).forEach(function (selector) {
        var previous = selector.previousElementSibling;
        if (previous && previous.matches(CONFIG.selectors.vendorLine)) previous.classList.add('apex-uspm-dup');
      });
    }
    if (CONFIG.removals.trustLine) {
      queryAll(doc, CONFIG.selectors.stockWidget).forEach(function (widget) {
        var next = widget.nextElementSibling;
        while (next && /^(STYLE|SCRIPT|LINK|NOSCRIPT)$/.test(next.tagName)) next = next.nextElementSibling;
        if (next && next.matches(CONFIG.selectors.vendorLine)) next.classList.add('apex-uspm-dup');
      });
    }
    if (CONFIG.removals.proofSection) {
      queryAll(doc, CONFIG.selectors.richTextSection).forEach(function (section) {
        if (isLegacyProofText(section.textContent)) section.classList.add('apex-uspm-dup');
      });
    }
  }

  /* Diagnostic only: reports whether every existing scattered block is hidden. Absent blocks count as hidden. */
  function buildPhotoStack(doc, photos) {
    var stack = doc.createElement('div');
    stack.className = 'apex-uspm__photos';
    stack.setAttribute('aria-hidden', 'true');
    photos.forEach(function (photo, index) {
      var frame = doc.createElement('span');
      frame.className = 'apex-uspm__photo';
      frame.style.setProperty('--i', String(index));
      /* Painted as a CSS background (240px crop covers 2x screens): Apex's treatment review rejects JS src assignments. */
      var picture = doc.createElement('span');
      picture.className = 'apex-uspm__photo-img';
      picture.style.setProperty('--apex-uspm-photo', 'url("' + photoUrl(photo.base, 240) + '")');
      frame.appendChild(picture);
      stack.appendChild(frame);
    });
    return stack;
  }

  function buildChipList(doc, chips, extraClass, chipClass) {
    var list = doc.createElement('ul');
    list.className = 'apex-uspm__chips ' + extraClass;
    list.setAttribute('role', 'list');
    chips.forEach(function (chip) {
      var item = doc.createElement('li');
      item.className = 'apex-uspm__chip' + (chipClass ? ' ' + chipClass : '');
      item.textContent = chip;
      list.appendChild(item);
    });
    return list;
  }

  /* Clones the page's own anchor for a URL, so the module never sets a link destination itself (Apex treatment review). */
  function cloneSiteAnchor(doc, url) {
    var source = queryAll(doc, 'a[href]').filter(function (node) { return node.href === url; })[0];
    if (!source) return null;
    var anchor = source.cloneNode(false);
    anchor.removeAttribute('id');
    anchor.removeAttribute('class');
    return anchor;
  }

  function buildReturnLink(doc, claim, returnUrl) {
    var returnLink = cloneSiteAnchor(doc, returnUrl) || doc.createElement('span');
    returnLink.className = 'apex-uspm__return' + (returnLink.tagName === 'A' ? '' : ' apex-uspm__return--text');
    returnLink.textContent = claim.returnLabel;
    return returnLink;
  }

  function buildClaimRow(doc, claim, context) {
    var row = doc.createElement('li');
    row.className = 'apex-uspm__row';
    row.setAttribute('data-claim', claim.id);
    row.setAttribute('data-category', claim.category);
    if (claim.source) row.setAttribute('data-claim-source', claim.source);

    var hasDetail = Boolean(claim.detail);
    var wrapper = doc.createElement(hasDetail ? 'details' : 'div');
    wrapper.className = hasDetail ? 'apex-uspm__details' : 'apex-uspm__static';
    var summary = doc.createElement(hasDetail ? 'summary' : 'div');
    summary.className = 'apex-uspm__summary' + (hasDetail ? '' : ' apex-uspm__summary--static');
    var icon = buildSpan(doc, 'apex-uspm__icon');
    icon.setAttribute('aria-hidden', 'true');
    icon.appendChild(buildIcon(doc, claim.category));
    var textWrap = buildSpan(doc, 'apex-uspm__text');
    var head = doc.createElement('strong');
    head.className = 'apex-uspm__head';
    head.textContent = claim.head;
    var bodyText = buildSpan(doc, 'apex-uspm__body-text');
    bodyText.textContent = claim.body;
    textWrap.appendChild(head);
    textWrap.appendChild(bodyText);
    summary.appendChild(icon);
    summary.appendChild(textWrap);
    if (hasDetail) {
      var chevron = buildSpan(doc, 'apex-uspm__chevron');
      chevron.setAttribute('aria-hidden', 'true');
      summary.appendChild(chevron);
    }
    wrapper.appendChild(summary);

    if (hasDetail) {
      var detail = doc.createElement('div');
      detail.className = 'apex-uspm__detail';
      var detailText = doc.createElement('span');
      detailText.textContent = claim.detail;
      detail.appendChild(detailText);
      if (claim.returnLabel) {
        if (context.returnUrl) detail.appendChild(buildReturnLink(doc, claim, context.returnUrl));
        else {
          var returnText = doc.createElement('span');
          returnText.className = 'apex-uspm__return apex-uspm__return--text';
          returnText.textContent = claim.returnLabel;
          detail.appendChild(returnText);
        }
      }
      wrapper.appendChild(detail);
    }
    row.appendChild(wrapper);
    return row;
  }

  function createModule(doc, context) {
    var section = doc.createElement('section');
    section.className = 'apex-uspm apex-uspm--rows';
    section.setAttribute('data-apex-uspm', '1');
    section.setAttribute('aria-labelledby', 'apex-uspm-title');

    /* Proof header: optional photo stack + static title, sold line and Trustpilot line */
    var header = doc.createElement('div');
    header.className = 'apex-uspm__proof';
    if (context.photos.length) header.appendChild(buildPhotoStack(doc, context.photos));

    var proofText = doc.createElement('div');
    proofText.className = 'apex-uspm__proof-text';

    var title = doc.createElement('h2');
    title.id = 'apex-uspm-title';
    title.className = 'apex-uspm__title';
    title.textContent = locale.title;
    proofText.appendChild(title);

    var sold = doc.createElement('p');
    sold.className = 'apex-uspm__sold';
    sold.textContent = locale.sold;
    proofText.appendChild(sold);

    if (CONFIG.showTrustFooter) {
      var trustAnchor = context.trustUrl ? cloneSiteAnchor(doc, context.trustUrl) : null;
      var trust = trustAnchor || doc.createElement('p');
      trust.className = 'apex-uspm__trust';
      if (trustAnchor) {
        trust.target = '_blank';
        trust.rel = 'noopener';
      }
      var stars = doc.createElement('span');
      stars.className = 'apex-uspm__stars';
      stars.setAttribute('aria-hidden', 'true');
      for (var starIndex = 0; starIndex < 5; starIndex++) stars.appendChild(buildStar(doc));
      trust.appendChild(stars);
      var trustLabel = doc.createElement('span');
      trustLabel.textContent = locale.trust;
      trust.appendChild(trustLabel);
      proofText.appendChild(trust);
    }

    header.appendChild(proofText);
    section.appendChild(header);

    /* Claims body: fit chips + the three static rows */
    var body = doc.createElement('div');
    body.className = 'apex-uspm__body';
    body.appendChild(buildChipList(doc, locale.fitChips, 'apex-uspm__chips--fit', ''));

    var list = doc.createElement('ul');
    list.className = 'apex-uspm__list';
    list.setAttribute('role', 'list');
    locale.claims.forEach(function (claim) {
      if (claim.category === 'material') {
        if (context.material) list.appendChild(buildClaimRow(doc, materialClaimFor(claim, context.material), context));
        return;
      }
      list.appendChild(buildClaimRow(doc, claim, context));
    });
    body.appendChild(list);
    section.appendChild(body);

    /* Occasions: static title + chips */
    var occasions = doc.createElement('div');
    occasions.className = 'apex-uspm__occasions';
    var occasionTitle = doc.createElement('h3');
    occasionTitle.className = 'apex-uspm__occasions-title';
    occasionTitle.textContent = locale.occasionsTitle;
    occasions.appendChild(occasionTitle);
    occasions.appendChild(buildChipList(doc, locale.occasions, 'apex-uspm__chips--occasions', 'apex-uspm__chip--occasion'));
    section.appendChild(occasions);

    return section;
  }

  /* Late hydration: the return link and the photo stack live below the anchor and may be parsed after the module renders. */
  function hydrateLateBits(doc, state) {
    var module = state.module;
    if (!module) return true;
    var complete = true;
    if (!module.querySelector('.apex-uspm__return[href]')) {
      var returnUrl = findReturnUrl(doc);
      var returnTextNode = module.querySelector('.apex-uspm__return--text');
      var shippingClaim = locale.claims.filter(function (claim) { return Boolean(claim.returnLabel); })[0];
      if (returnUrl && returnTextNode && shippingClaim) {
        returnTextNode.parentNode.replaceChild(buildReturnLink(doc, shippingClaim, returnUrl), returnTextNode);
        state.context.returnUrl = returnUrl;
      } else if (!returnUrl) complete = false;
    }
    var currentMaterialRow = module.querySelector('[data-category="material"]');
    if (!currentMaterialRow || currentMaterialRow.getAttribute('data-claim-source') !== 'material') {
      var material = readMaterialClaim(doc);
      var baseClaim = locale.claims.filter(function (claim) { return claim.category === 'material'; })[0];
      var list = module.querySelector('.apex-uspm__list');
      var currentSource = currentMaterialRow ? currentMaterialRow.getAttribute('data-claim-source') : null;
      if (material && baseClaim && list && material.source !== currentSource) {
        var freshRow = buildClaimRow(doc, materialClaimFor(baseClaim, material), state.context);
        if (currentMaterialRow) list.replaceChild(freshRow, currentMaterialRow);
        else list.insertBefore(freshRow, list.firstChild);
        state.context.material = material;
      }
      if (!material) complete = false;
    }
    if (!module.querySelector('.apex-uspm__photos')) {
      var photos = readProofPhotos(doc, CONFIG.proofPhotos);
      var header = module.querySelector('.apex-uspm__proof');
      if (photos.length && header) {
        header.insertBefore(buildPhotoStack(doc, photos), header.firstChild);
        state.context.photos = photos;
      } else if (!photos.length) complete = false;
    }
    return complete;
  }

  function mount() {
    var doc = root.document;
    var state = {
      active: true,
      observer: null,
      anchorTimer: null,
      workTimer: null,
      module: null,
      context: null,
      rendered: false,
      hydrated: false,
      hydrateUntil: 0,
      listeners: []
    };
    var html = doc.documentElement;
    html.classList.add('apex-uspm-pending');

    function listen(target, type, handler) {
      target.addEventListener(type, handler);
      state.listeners.push([target, type, handler]);
    }

    function cleanupClasses() {
      html.classList.remove('apex-uspm-pending');
      html.classList.remove('apex-uspm-active');
      queryAll(doc, '.apex-uspm-dup').forEach(function (node) { node.classList.remove('apex-uspm-dup'); });
    }

    function destroy() {
      state.active = false;
      if (state.observer) state.observer.disconnect();
      if (state.anchorTimer) root.clearTimeout(state.anchorTimer);
      if (state.workTimer) root.clearTimeout(state.workTimer);
      state.anchorTimer = null;
      state.workTimer = null;
      state.listeners.forEach(function (entry) { entry[0].removeEventListener(entry[1], entry[2]); });
      state.listeners = [];
      if (state.module) state.module.remove();
      queryAll(doc, '[data-apex-uspm="1"]').forEach(function (node) { node.remove(); });
      cleanupClasses();
      if (root.__apexUspModule === state) delete root.__apexUspModule;
    }

    /* Only genuine failures end here: no anchor after the timeout, or an exception while rendering. */
    function fallback() {
      if (state.active) destroy();
    }

    /* Keeps the rendered module in place while the page keeps mutating; never tears it down. */
    function ensurePlaced() {
      if (!state.active || !state.rendered) return;
      markDuplicates(doc);
      var placement = resolvePlacement(doc, true);
      queryAll(doc, '[data-apex-uspm="1"]').forEach(function (node) {
        if (node !== state.module) node.remove();
      });
      if (placement) placeModule(placement, state.module);
      if (!state.hydrated && Date.now() <= state.hydrateUntil) {
        state.hydrated = hydrateLateBits(doc, state);
      }
    }

    function tryRender() {
      if (!state.active || state.rendered) return;
      var placement = resolvePlacement(doc, doc.readyState !== 'loading');
      if (!placement) return;
      var context = readProductContext(doc);
      state.context = context;

      try {
        markDuplicates(doc);
        state.module = createModule(doc, context);
        placeModule(placement, state.module);
        html.classList.add('apex-uspm-active');
        html.classList.remove('apex-uspm-pending');
        state.rendered = true;
        state.hydrateUntil = Date.now() + CONFIG.hydrateWindowMs;
        state.hydrated = Boolean(context.returnUrl) && context.photos.length > 0 && Boolean(context.material && context.material.source === 'material');
        if (state.anchorTimer) root.clearTimeout(state.anchorTimer);
        state.anchorTimer = null;

      } catch (error) {
        fallback();
      }
    }

    /* Coalesces DOM-mutation bursts into one pass via a macrotask (rAF is skipped in hidden tabs). */
    function scheduleWork() {
      if (!state.active || state.workTimer !== null) return;
      state.workTimer = root.setTimeout(function () {
        state.workTimer = null;
        if (state.rendered) ensurePlaced();
        else tryRender();
      }, 0);
    }

    /* The anchor timeout only starts once the DOM is parsed, so a slow document cannot expire it. */
    function armAnchorTimeout() {
      if (!state.active || state.rendered || state.anchorTimer) return;
      state.anchorTimer = root.setTimeout(function () {
        state.anchorTimer = null;
        if (!state.rendered) fallback();
      }, CONFIG.anchorTimeoutMs);
    }

    function onDomReady() {
      armAnchorTimeout();
      scheduleWork();
    }

    state.destroy = destroy;
    root.__apexUspModule = state;
    state.observer = new root.MutationObserver(scheduleWork);
    var observeRoot = doc.querySelector(CONFIG.selectors.observeRoot) || doc.body || doc.documentElement;
    state.observer.observe(observeRoot, { childList: true, subtree: true });
    listen(root, 'pageshow', function (event) {
      if (event.persisted && state.rendered) ensurePlaced();
    });
    listen(root, 'load', scheduleWork);
    if (doc.readyState === 'loading') listen(doc, 'DOMContentLoaded', onDomReady);
    else onDomReady();
    tryRender();
  }

  mount();
})(window);
